export default "__VITE_ASSET__D8905WE___"